var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "119px",
    height: "119px",
    viewBox: "0 0 1190 1190",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer101",
    fill: "#627482",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436 1175 c-209 -59 -382 -240 -426 -446 -18 -83 -9 -260 18 -333 62 -170 196 -304 368 -369 51 -19 79 -22 199 -22 120 0 148 3 199 22 172 65 304 197 369 369 19 51 22 79 22 199 0 120 -3 148 -22 199 -65 172 -199 306 -369 368 -75 28 -281 35 -358 13z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer102",
    fill: "#a9b3bb",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131 974 c-155 -176 -173 -474 -44 -688 160 -263 497 -359 782 -224 47 22 89 54 147 112 86 86 132 163 159 266 19 71 19 239 0 310 -20 76 -68 170 -114 221 l-38 43 -18 -33 c-25 -49 -100 -126 -150 -156 l-43 -25 -54 28 c-48 24 -63 27 -158 27 -95 0 -110 -3 -158 -27 l-54 -28 -41 25 c-53 31 -119 98 -150 153 l-24 43 -42 -47z m596 -230 c54 -26 92 -68 123 -136 30 -66 28 -216 -4 -283 -27 -60 -103 -131 -155 -145 -46 -13 -136 -13 -182 0 -52 14 -128 85 -155 145 -20 41 -24 67 -24 143 0 99 11 138 57 205 69 100 216 131 340 71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefault);
export default __webpack_public_path__ + "static/media/icon_default.324ae5c1b17c5cd815bcf1995672084a.svg";
export { ForwardRef as ReactComponent };